export const ELIGIBILITY_TOOLTIP_CONTENT: Record<string, string> = {
  eligible:
    'Products available to applicants who are likely to qualify based on their health status',
  unsure: 'Products that may require additional health review or underwriting',
  ineligible:
    "Products likely are not available because applicants do not meet carriers' health requirements",
};

export const FEATURE_BENEFITS_LABELS: Record<string, string> = {
  hasGlobalBenefits: 'International Benefits',
};
